import { Environment } from '@/enums/environment';
import { EnvironmentConfig } from '@/types/environment';

const ENVIRONMENT_CONFIGS: Record<Environment, EnvironmentConfig> = {
    [Environment.LOCAL]: {
        VITE_API: 'https://api-dev.gls-group.net',
        VITE_AZURE_B2C_AUTHORITY: 'https://glsgrouptest.b2clogin.com/glsgrouptest.onmicrosoft.com/B2C_1A_LOCAL_SUSI',
        VITE_AZURE_B2C_CLIENT_ID: 'fdf0a7de-c3ce-452f-9d63-1f535e6621e1',
        VITE_AZURE_B2C_KNOWN_AUTHORITIES: 'glsgrouptest.b2clogin.com',
        VITE_AZURE_AD_CLIENT_ID: 'd990b330-8288-4d12-b614-cd59cb94fc31'
    },
    [Environment.DEV]: {
        VITE_API: 'https://api-dev.gls-group.net',
        VITE_AZURE_B2C_AUTHORITY: 'https://glsgrouptest.b2clogin.com/glsgrouptest.onmicrosoft.com/B2C_1A_LOCAL_SUSI',
        VITE_AZURE_B2C_CLIENT_ID: 'fdf0a7de-c3ce-452f-9d63-1f535e6621e1',
        VITE_AZURE_B2C_KNOWN_AUTHORITIES: 'glsgrouptest.b2clogin.com',
        VITE_AZURE_AD_CLIENT_ID: 'd990b330-8288-4d12-b614-cd59cb94fc31'
    },
    [Environment.STAGE]: {
        VITE_API: 'https://api-qas.gls-group.net',
        VITE_AZURE_B2C_AUTHORITY: 'https://glsgrouptest.b2clogin.com/glsgrouptest.onmicrosoft.com/B2C_1A_LOCAL_SUSI',
        VITE_AZURE_B2C_CLIENT_ID: 'fdf0a7de-c3ce-452f-9d63-1f535e6621e1',
        VITE_AZURE_B2C_KNOWN_AUTHORITIES: 'glsgrouptest.b2clogin.com',
        VITE_AZURE_AD_CLIENT_ID: 'd990b330-8288-4d12-b614-cd59cb94fc31'
    },
    [Environment.PROD]: {
        VITE_API: 'https://api.gls-group.net',
        VITE_AZURE_B2C_AUTHORITY: 'https://glsgroup.b2clogin.com/glsgroup.onmicrosoft.com/B2C_1A_LOCAL_SUSI',
        VITE_AZURE_B2C_CLIENT_ID: '8196b452-8419-4c75-8b63-a0d9e49355a5',
        VITE_AZURE_B2C_KNOWN_AUTHORITIES: 'glsgroup.b2clogin.com',
        VITE_AZURE_AD_CLIENT_ID: '0182c721-469a-462a-8f0d-fb67e74332b7'
    }
};

export { ENVIRONMENT_CONFIGS };
